import { render, staticRenderFns } from "./artifact-block.vue?vue&type=template&id=2fa3e1cc&scoped=true"
import script from "./artifact-block.vue?vue&type=script&lang=ts"
export * from "./artifact-block.vue?vue&type=script&lang=ts"
import style0 from "./artifact-block.vue?vue&type=style&index=0&id=2fa3e1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3e1cc",
  null
  
)

export default component.exports